import { cn } from '@hero/web-lib';

/**
 * Subtle, edge-hugging scrollbar for the chat transcript.
 *
 * Sits on the inline-end of the scroll container (right in LTR, left in
 * RTL) because the overflow root spans the full panel width. The thumb
 * is nearly invisible until hover so it doesn't compete with the prose.
 */
export const chatScrollClasses = cn(
  'min-h-0 overflow-y-auto overscroll-y-contain',
  '[scrollbar-width:thin]',
  '[scrollbar-color:rgb(203_213_225/0.35)_transparent]',
  '[&::-webkit-scrollbar]:w-1',
  '[&::-webkit-scrollbar-track]:bg-transparent',
  '[&::-webkit-scrollbar-thumb]:rounded-full',
  '[&::-webkit-scrollbar-thumb]:bg-slate-200/0',
  '[&:hover::-webkit-scrollbar-thumb]:bg-slate-200/55',
  '[&::-webkit-scrollbar-thumb:hover]:bg-slate-300/75',
);

export const chatContentClasses = (layout: 'floating' | 'page') =>
  cn(
    'py-6',
    layout === 'page'
      ? 'mx-auto w-full max-w-3xl px-4 sm:px-6'
      : 'px-4 sm:px-6',
);
